import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { CustomerDetails } from './../../../_models/customer/customer-details.model';
import { AlertService, RequestHelperProvider } from './../../../_services/services';
import { CustomerRequest } from '../../../_models/customer/customer-request.model';
import { CustomerServiceProvider } from './../../../_services/customer.service';
import { Global } from 'src/app/globals';
import * as Sentry from '@sentry/angular';
import { Helpers } from 'src/app/_models/helpers';
import { Router, ActivatedRoute } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { LoadingService } from 'src/app/_services/loading.service';

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule
  ],
})
export class CustomerSearchComponent implements OnInit {

  customerRequest: CustomerRequest = new CustomerRequest();
  customers: CustomerDetails[];
  currentWidth: number;

  @Output() sendResponseEventEmitter = new EventEmitter<any>();
  @Input() forSalesOrder: boolean;
  @Input() selectedEmailType: string;

  constructor(
    private alertService: AlertService,
    public globals: Global,
    public customerService: CustomerServiceProvider,
    private requestHelper: RequestHelperProvider,
    private router: Router,
    private route: ActivatedRoute,
    private blockUI: LoadingService
  ) {
    this.currentWidth = window.innerWidth;
  }

  ngOnInit() {
    //this.moveSearchButton();
  }

  searchCustomer() {

    console.log("in search");

    this.alertService.clear();
    this.blockUI.start();

    if (this.customerRequest.nameId === '' && this.customerRequest.name === '' && this.customerRequest.city === '' && this.customerRequest.phoneNumber === '') {
      this.blockUI.stop();
      return;
    }
    this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
      //   GetCustomersLiveFromNameAddress
      //  this.customerService.GetCustomersLive(this.customerRequest, (response) => {
      this.customerService.GetCustomersLiveFromNameAddress(this.customerRequest, this.selectedEmailType).then((response) => {
        if (response.errorMessage) {
          this.alertService.error(response.errorMessage);
          this.blockUI.stop();
          return;
        }

        if (response.length == 0) {
          this.alertService.warning('No matching customers found.', false, true);
          this.customers = [];
          this.sendResponse();
          this.blockUI.stop();
        } else {
          this.blockUI.stop();
          this.customers = response;
          this.sendResponse();
        }
      }).catch((error) => {
        if (error.Code == 404) {
          this.blockUI.stop();
          this.alertService.error(error.Code == 401 ? 'Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.' : error.Message);
        } else {
          this.blockUI.stop();
          Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
          this.alertService.error(error.Code == 401 ? 'Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.' : error.Message);

        }

      });
    }).catch((err) => {
      console.log(err);
      this.blockUI.stop();
    });;
    // this.globals.signalR.SearchCustomers(this.customerRequest);

    // this.globals.signalR.OnResponse('returnedCustomersList', this.onSearchRespondsCustomers.bind(this));

  }
  // onSearchRespondsCustomers(response: any) {
  //   if (response.errorMessage) {
  //     this.alertService.error(response.errorMessage);
  //     this.blockUI.stop();
  //     return;
  //   }

  //   if (response.length == 0) {
  //     this.alertService.warning('No matching customers found.', false, true);
  //     this.blockUI.stop();
  //   } else {
  //     this.blockUI.stop();
  //     this.customers = response;
  //     this.sendResponse();
  //   }
  // }
  sendResponse() {
    this.sendResponseEventEmitter.emit({ customer: this.customers, request: this.customerRequest });
  }

  moveSearchButton() {
    var inputFieldWidth = 0;
    var searchButtonWidth = 0;
    var totalWidth = 0;
    var field;

    field = document.getElementById("divSearch");
    if (field) {
      if (this.currentWidth < 768) {
        field.setAttribute("hidden", "true");
      }
      else {
        field.removeAttribute("hidden");

        field = document.getElementById("inputFields");
        inputFieldWidth = field.offsetWidth;

        field = document.getElementById("searchButton");
        //if (field != null){
        searchButtonWidth = field.offsetWidth;

        var totalWidth = inputFieldWidth - searchButtonWidth;

        field = document.getElementById("leftSpace");
        field.setAttribute("style", "margin-left: " + totalWidth.toString() + "px");
        //}
      }
    }
  }

  onResize(event) {
    //this.currentWidth = window.innerWidth;
    this.currentWidth = event.target.innerWidth;
    //console.log("width:" + window.innerWidth);

    //this.moveSearchButton();
  }
  onEnter() {
    if ((this.customerRequest.nameId == '' || this.customerRequest.nameId.length < 3) && (this.customerRequest.name == '' || this.customerRequest.name.length < 3) && (this.customerRequest.city == '' || this.customerRequest.city.length < 3) && (this.customerRequest.phoneNumber == '' || this.customerRequest.phoneNumber.length < 4)) {
      return;
    } else {
      this.searchCustomer();
    }
  }


  openBookingsComplete() {
    Helpers.LogInfo("before navigation", "openBookingsComplete");

    //  location.href = "bookingcomplete?mode=Order;bookingReceiptNumber=18666";

    ///bookingcomplete;mode=Book;Btn=BOOKING;bookingReceiptNumber=19640
    this.router.navigate(['bookingcomplete', { mode: 'Book', Btn: 'booking', bookingReceiptNumber: '19640' }]);
  }
}
